export default __webpack_public_path__ + "static/media/help_center.d2b96ec2.svg";